import React, { createContext, useContext } from 'react';
import { useDashboard } from './useDashboard.js';

const DashboardContext = createContext(null);

export function DashboardProvider({ children }) {
  const value = useDashboard();
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
}

export function useDashboardContext() {
  const ctx = useContext(DashboardContext);
  if (!ctx) return null;
  return ctx;
}

export function useDashboardOrContext() {
  const ctx = useDashboardContext();
  if (ctx) return ctx;
  return useDashboard();
}
